import { API_BASE, getApiHeaders } from './apiClient';

export type StakeholderCategory = 'INTERNAL' | 'EXTERNAL';

export interface Stakeholder {
  id:        number;
  clientId:  number;
  category:  StakeholderCategory;
  role:      string;
  name:      string;
  contact:   string | null;
  email:     string | null;
  isActive:  boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StakeholderDTO {
  category: StakeholderCategory;
  role:     string;
  name:     string;
  contact?: string;
  email?:   string;
}

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res  = await fetch(`${API_BASE}${path}`, {
    headers: { ...getApiHeaders(), ...(options?.headers || {}) },
    ...options,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `Request failed: ${res.status}`);
  return data as T;
}

export async function listStakeholders(): Promise<Stakeholder[]> {
  const d = await apiFetch<{ stakeholders: Stakeholder[] }>('/cima/stakeholders');
  return d.stakeholders;
}

export async function createStakeholder(dto: StakeholderDTO): Promise<Stakeholder> {
  const d = await apiFetch<{ stakeholder: Stakeholder }>('/cima/stakeholders', {
    method: 'POST',
    body:   JSON.stringify(dto),
  });
  return d.stakeholder;
}

export async function updateStakeholder(id: number, dto: Partial<StakeholderDTO>): Promise<Stakeholder> {
  const d = await apiFetch<{ stakeholder: Stakeholder }>(`/cima/stakeholders/${id}`, {
    method: 'PATCH',
    body:   JSON.stringify(dto),
  });
  return d.stakeholder;
}

export async function deleteStakeholder(id: number): Promise<void> {
  await apiFetch(`/cima/stakeholders/${id}`, { method: 'DELETE' });
}
